//@ts-nocheck

import React from 'react';

import Img from "../../assets/imgs/img-2.png";
import BgCard from "../../assets/imgs/bg-card2.png";

const cards = [
	{
		value: 76,
		title: "Military-Grade Encryption: Lock down your online activity. We use the strongest encryption protocols to ensure your data, from banking details to private messages, remains for your eyes only.",
		desc: "Source: PwC"
	},
	{
		value: 85,
		title: "Secure Public Wi-Fi: Browse with confidence. Connect to any public network knowing RivalShield is actively protecting you from data thieves and cyber snoopers.",
		desc: "Source: PwC"
	},
	{
		value: 68,
		title: "No-Logs Privacy: Your privacy is our policy. We are committed to a strict no-logs policy, meaning your online activity is not tracked, stored, or exposed.",
		desc: "Source: PwC"
	},
	{
		value: 68,
		title: "Lightning-Fast Speeds: Experience the internet without borders or buffering. Our optimized global network is built for speed, ensuring smooth video calls, HD streaming, and responsive browsing.",
		desc: "Source: PwC"
	},
	{
		value: 68,
		title: "One-Tap Connection: Simplicity is key. Get protected with a single tap. Our intuitive interface makes securing your connection effortless.",
		desc: "Source: PwC"
	},
	{
		value: 68,
		title: "Uninterrupted Access: Enjoy a stable and reliable connection for all your apps and services, wherever you are.",
		desc: "Source: PwC"
	},
];

const GlobalExpansion = () => {

	return (
		<div id="expansion" className='relative w-full px-[20px] pt-[80px] lg:pt-[150px]'>
			<div className='max-w-full w-[1440px] mx-auto flex flex-col lg:flex-row justify-between items-center gap-20'>
				<div className='w-full flex flex-col items-center'>
					<div className='text-[24px] lg:text-[48px] text-start font-[500] h-[40px] lg:h-[80px] lg:mb-[10px] bg-gradient-to-b from-[#FFFFFF] to-[#999999] bg-clip-text text-transparent'>
						Why Choose RivalShield VPN?
					</div>
					<div className='text-[16px] lg:text-[18px] text-start font-[400] text-[#B3B3B3] lg:leading-[30px] max-w-[717px] mb-[32px] lg:mb-[54px] '>
						Enterprise insights that shape the future of international business
					</div>
					<div className='grid grid-cols-1 md:grid-cols-3 gap-[30px]'>
						{cards.map((item, index) =>
						(
							<div key={index} className='relative w-[335px] h-[225px] p-[2px] bg-gradient-to-b from-[rgba(73,73,73,0.5)] to-[rgba(73,73,73,0)] rounded-[16px] hover:scale-110 transition-all duration-500'>
								<div className='relative w-full h-full p-[24px] flex flex-col justify-center items-center overflow-hidden bg-gradient-to-b from-[rgba(30,30,30,1)] to-[rgba(21,21,21,1)] rounded-[16px]'>
									<img src={BgCard} className='w-[409px] absolute top-0 right-0 z-10' alt='bg' />
									<div className='text-white text-center text-[18px] z-20'>{item.title}</div>
								</div>
							</div>
						)
						)}
					</div>
				</div>
			</div>
		</div>
	);
};

export default GlobalExpansion;
